import { NAME_PRODUCTS, NAME_BRAND_ASSETS, NAME_COMPENSATION, NAME_CONTENT_AGREEMENT, NAME_NETWORKS, NAME_SHIPPING_INFO, NAME_PERSONAL_INFO, NAME_TASKS, NAME_UPLOAD_FILES } from './activation-brief-steps';
export const ACTIVATION_BRIEF_CUSTOMIZED_STEP_TITLE_KEYS = {
    [NAME_COMPENSATION]: 'live_payment_title',
    [NAME_PRODUCTS]: 'products_title',
    [NAME_PERSONAL_INFO]: 'additional_information_title',
    [NAME_TASKS]: 'live_tasks_title',
    [NAME_UPLOAD_FILES]: 'upload_files_title',
    [NAME_NETWORKS]: 'networks_title',
    [NAME_SHIPPING_INFO]: 'products_shipping_information_title',
    [NAME_BRAND_ASSETS]: 'brand_assets_title',
    [NAME_CONTENT_AGREEMENT]: 'content_rights_title'
};
